'use strict'

var rtpsData;
var prescreenedInCheckout = false;
var reloadAfterApproval = false;

function submitRTPS(buyerDetails, location){
    prescreenedInCheckout = location === 'checkout';
    if(typeof BreadPayments === 'undefined'){
        return;
    }
    if(BreadPayments && buyerDetails){
        if(buyerDetails.phone){
            buyerDetails.phone = buyerDetails.phone;
        }
        if(buyerDetails.billingAddress && buyerDetails.billingAddress.postalCode && buyerDetails.billingAddress.postalCode.length > 5){
            buyerDetails.billingAddress.postalCode = buyerDetails.billingAddress.postalCode.substring(0, 5);
        }
        rtpsData = buyerDetails;
        BreadPayments.setup({
            env: $('.eds-rtps-data').data('prescreen-env'), //TO DO: get env and store number dynamically
            storeNumber: ''+$('.eds-rtps-data').data('prescreen-store-number'),
            buyer: buyerDetails
        });
    }
    BreadPayments.submitRtps({
        financingType: 'card',
        locationType: location ? location : 'checkout'
    });
}

function initEventListeners(){
    if(typeof window.EDSEventsInitialized !== 'undefined' && window.EDSEventsInitialized){
        //EDS event listeners alread initialized
        return;
    }
    if($('.eds-rtps-data').length == 0){
        //EDS it not enabled
        return;
    }
    if(typeof BreadPayments === 'undefined'){
        //EDS is enabled but BreadPayments is not ready yet
        setTimeout(initEventListeners, 300);
        return;
    }
    window.EDSEventsInitialized = true;
    $(document).on('click', '.eds-accept-now', function(e){
        e.preventDefault();
        $.ajax({
            url: $('.eds-rtps-data').data('prescreen-data-url'),
            method: 'GET',
            contentType: 'application/json',
            success: function(response){
                if(response.dataFound){
                    var prescreenData = response.rtpsData;
                    if(BreadPayments && prescreenData){
                        submitRTPS(prescreenData);
                    }
                }
            }
        });
    });
    
     //prevent scroll on bread placements (from href="#" used for WCAG)
    $("[id*=bread-payments]").on('click', function(e){
        e.preventDefault()
    });
    if(BreadPayments){
        BreadPayments.on('CARD:VIEW_PAGE', function(data) {
            if(data.pageName === 'prescreen/offer'){
                //Update customer profile
                $.ajax({
                    url: $('.eds-rtps-data').data('prescreen-details-url'),
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify($.extend(rtpsData, {isPrescreenedInCheckout: prescreenedInCheckout}))
                });
            }
          });
        BreadPayments.on('CARD:OFFER_RESPONSE', function(data) {
            if(data === 'NO'){
                $.ajax({
                    url: $('.eds-rtps-data').data('offer-response-url'), 
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({offerResponse: data}),
                    success: function (data) {
                        //var fail = false;
                        if ($('.pt_checkout .spc-summary').length > 0) {
                              require('../../../../../../../../../cartridges/app_fbb_core_sfra/cartridge/js/spc').initPreScreen();
                        } else {
                              if($('.express-billing-refresh').length > 0) {
                                  $(".express-billing-refresh[data-refreshurl]").trigger('click'); 
                              } else {
                                  $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                              }
                        }
                    }
                });
            }
        });
        BreadPayments.on('CARD:RECEIVE_APPLICATION_RESULT', function(result){
            if(result.result === 'APPROVED'){
                result.responseType = 'instantCredit';
                $.ajax({
                    url: $('.eds-rtps-data').data('card-approved-url'), 
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(result),
                    success: function(data){
                        if ($('.pt_checkout .spc-summary').length > 0) {
                            require('../../../../../../../../../cartridges/app_fbb_core_sfra/cartridge/js/spc').initPreScreen();
                        } else {
                            if($('.express-billing-refresh').length > 0) {
                                $(".express-billing-refresh[data-refreshurl]").trigger('click'); 
                            } else if($(".spc-billing .billing-refresh").length > 0) {
                                $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                            } else {
                                reloadAfterApproval = true;
                            }
                      }
                    }
                });
                //AZ-6942 Enroll current user in rewards program if authenticated and approved in CA PLCC.
                if($("body").data("brand-id")=='ca' && window.SessionAttributes.IS_CUSTOMER_AUTHENTICATED){
                    var tokenName = $('.eds-carewards-data').data('csrf-token-name');
                    var tokenValue = $('.eds-carewards-data').data('csrf-token-value');
                    var data = {};
                    data[tokenName] = tokenValue;
                    data["rewardsEnrollFromEds"] = true;
                    $.ajax({
                        url: $('.eds-carewards-data').data('rewards-register-url'), 
                        method: 'POST',
                        data: data,
                        contentType: 'application/x-www-form-urlencoded'
                    }); 
                } 
            }
        });
        BreadPayments.on('CARD:APPLICATION_COMPLETED', function(){
            if(reloadAfterApproval){
                setTimeout(() => window.location.reload(), 0);
            }
        });
    }
}

module.exports = {
    initEventListeners: initEventListeners,
    submitRTPS: submitRTPS
}